import useResource from 'app/hooks/useResource';

import {
  getJobConfigs,
  setJobConfigParams
} from 'app/actions/jobConfigs';

import {
  createJobConfig,
  updateJobConfig,
  destroyJobConfig
} from 'app/services/jobConfigs';

import {
  jobConfigs as resource
} from 'app/resources';

const useJobConfigs = () => {
  return useResource({
    resource,
    getResource: getJobConfigs,
    createResource: createJobConfig,
    updateResource: updateJobConfig,
    destroyResource: destroyJobConfig,
    setResourceParams: setJobConfigParams
  });
}

export default useJobConfigs;
